/*jslint browser */
/*global process */

var $ = jQuery;

/**
 *
 */
export default class Item
{
    private _id: number;
    private _name: string;
    private _type: string;
    private _price: number;
    private _generatorImegeUrl: string;

    get id(): number {
        return this._id;
    }

    set id(value: number) {
        this._id = value;
    }

    get name(): string {
        return this._name;
    }

    set name(value: string) {
        this._name = value;
    }

    get type(): string {
        return this._type;
    }

    set type(value: string) {
        this._type = value;
    }

    get price(): number {
        return this._price;
    }

    set price(value: number) {
        this._price = value;
    }

    get generatorImegeUrl(): string {
        return this._generatorImegeUrl;
    }

    set generatorImegeUrl(value: string) {
        this._generatorImegeUrl = value;
    }
}